export const STRIPE_PUBLISHABLE_KEY = import.meta.env.VITE_STRIPE_PUBLISHABLE_KEY || '';
// The default venue is identified by its slug — a stable, environment-independent
// value (the Flyway seed uses the same slug everywhere). The location's UUID is
// resolved at runtime via useVenueBySlug(DEFAULT_VENUE_SLUG); don't reintroduce
// a hardcoded location-ID constant — Flyway uses gen_random_uuid() so the UUID
// differs per fresh DB and a literal goes stale (Day 1 Sprint 8 live test bug).
export const DEFAULT_VENUE_SLUG = import.meta.env.VITE_DEFAULT_VENUE_SLUG || 'rekplay-hub-pickering';
// Same reasoning as DEFAULT_VENUE_SLUG: the tenant slug is environment-stable
// across Flyway seeds; the UUID it resolves to is not. Use useTenantBySlug
// (frontend/src/api/hooks/useTenantBySlug.ts) at the call site instead of
// importing a literal UUID. Removed VITE_DEFAULT_TENANT_ID env var entirely.
export const DEFAULT_TENANT_SLUG = import.meta.env.VITE_DEFAULT_TENANT_SLUG || 'recplay-hub';
export const DEFAULT_LOCALE = import.meta.env.VITE_DEFAULT_LOCALE || 'en';
export const SUPPORTED_LOCALES = ['en', 'fr'] as const;
